import { DetailsComponent } from './details/details.component';
import { MyaccountComponent } from './myaccount/myaccount.component';
import { TcComponent } from './tc/tc.component';
import { FaqComponent } from './faq/faq.component';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArcadeComponent } from './arcade/arcade.component';
import { AdventureComponent } from './adventure/adventure.component';
import { PlgComponent } from './plg/plg.component';
import { LiveLoadingComponent } from './live-loading/live-loading.component';
import { NewFaqComponent } from './new-faq/new-faq.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'arcade',
    component: ArcadeComponent
  },
  {
    path: 'adventure',
    component: AdventureComponent
  },
  {
    path: 'plg',
    component: PlgComponent
  },
  {
    path: 'tc',
    component: TcComponent
  },
  {
    path: 'account',
    component: MyaccountComponent
  },
  {
    path: 'details',
    component: DetailsComponent
  },
  {
    path: 'live-load',
    component: LiveLoadingComponent
  },
  {
    path: 'new-faq',
    component: NewFaqComponent
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
